/**
 * 申请下载按钮组件
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Modal} from 'antd';
import {message} from './Mess'
import MyIconSvg from "./svg/Svg"
import BaseComponent from "../../../base/BaseComponent";
import Apply from "./apply";


const {confirm} = Modal


export default class AskFor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");
        const isShow = this.permissionCheck('zyk_appliction_download_show');
        return (
            <>
            {isShow? (
            <div>
                <div onClick={this.showModalApply}>{
                    this.props.text ? <span>申请下载</span> : <Button  style={{marginRight: 5,display: 'flex', alignItems:'center'}}><MyIconSvg type={"DownloadResourcesIcon"} style={{marginTop:'2px'}} colors={[newSecondSelectColor]}/>申请下载</Button>
                }
                </div>
                <Apply ref={(currentId) => this.showApply = currentId}
                       disabled={false}
                       title={'新增申请'}
                       callBackData={() => {
                          this.props.callBack&&this.props.callBack()
                       }}></Apply>
            </div>
            ) : null}
            </>
        )
    }
    //申请下载：
    //
    // 1、含文件夹：（暂不支持文件夹申请下载。）
    // 2、含未公开资源、公开资源：（所选资源包含公开资源，当前仅申请下载非公开资源？）
    // 3、未公开资源：直接申请下载。
    // 4、公开资源：（所选资源为公开资源，请直接下载。）
    showModalApply = (record) => {
        let num = 0; //选中的文件夹的个数
        let downloadNum = 0;
        let newArray = [];
        if (this.props.checkArray.length) {
            this.props.checkArray && this.props.checkArray.length && this.props.checkArray.forEach((item, index) => {
                if (item.fileTypeEnum === 'FILE') {
                    if (item.extendedAttributeJson && item.extendedAttributeJson.download) {
                        downloadNum++;
                        newArray.push(item)
                    }
                } else {
                    num++
                }
            });
            if (num) {
                message.error('暂不支持文件夹申请下载！');
                return false
            } else {
                if (downloadNum === this.props.checkArray.length) {
                    this.showApply.show(true, newArray)
                } else if (downloadNum === 0) {
                    message.error('所选资源无需申请，请直接下载使用！')
                } else {
                    confirm({
                        content: '所选资源中，含无需申请下载的资源，请自行下载，当前仅申请下载没有使用权限的资源？',
                        okText: '确定',
                        cancelText: '取消',
                        onOk: () => {
                            this.showApply.show(true, newArray)
                        },
                        onCancel() {
                        },
                    });
                }
            }

        } else {
            message.error('至少选择一个文件！')
        }
    }
}
